import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import CouponActions from '../../Redux/CouponRedux'

class IndividualEcommerce extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: 'inventory',
      selectedInventory: null,
      selectedCategory: null,
      form: {
        discountable_type: '',
        discountable_id: ''
      }
    }
  }

  _changeTab = (tab) => {
    this.setState({ tab })
  }

  _selectChange = (e, field) => {
    let form = { ...this.state.form }
    if (field === 'inventory') {
      form.discountable_id = e.value
      form.discountable_type = 'inventory'
      this.setState({
        selectedInventory: e,
        form
      })
    } else if (field === 'category') {
      form.discountable_id = e.value
      form.discountable_type = 'category'
      this.setState({
        selectedCategory: e,
        form
      })
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    if (this.props.source_type === 'coupon-user') {
      let uuid = this.props.uuid
      let data = { uuid, form }
      this.props.postCouponItem(data)
    } else {
      let tag = this.props.tag
      let data = { tag, form }
      this.props.postCouponItemTag(data)
    }
    setTimeout(() => {
      this.props.fetchCouponItem()
    }, 500)
  }

  render () {
    const { inventory, category } = this.props
    let inventoryPicker = []
    inventory.custom.map((item, i) => (
      inventoryPicker[i] = {
        value: item.id,
        label: item.name
      }
    ))

    let categoryPicker = []
    category.data.map((item, i) => (
      categoryPicker[i] = {
        value: item.id,
        label: item.name
      }
    ))

    return (
      <section>
        <div className='btn-group mb-3' role='group'>
          <button onClick={() => this._changeTab('inventory')} className={`btn btn-primary ${this.state.tab === 'inventory' ? 'active' : ''}`}>Inventory</button>
          <button onClick={() => this._changeTab('category')} className={`btn btn-primary ${this.state.tab === 'category' ? 'active' : ''}`}>Category</button>
        </div>
        {
          this.state.tab === 'inventory' &&
          <form onSubmit={(event) => this._submit(event)}>
            <div className='form-group row'>
              <div className='col-10'>
                <Select
                  options={inventoryPicker}
                  value={this.state.selectedInventory}
                  onChange={(e) => this._selectChange(e, 'inventory')}
                  placeholder='Select Ecommerce Product to add ...'
                />
              </div>
              <div className='col-2'>
                <button type='submit' className='btn btn-primary'>Add</button>
              </div>
            </div>
          </form>
        }
        {
          this.state.tab === 'category' &&
          <form onSubmit={(event) => this._submit(event)}>
            <div className='form-group row'>
              <div className='col-10'>
                <Select
                  options={categoryPicker}
                  value={this.state.selectedCategory}
                  onChange={(e) => this._selectChange(e, 'category')}
                  placeholder='Select Ecommerce Category to add ...'
                />
              </div>
              <div className='col-2'>
                <button type='submit' className='btn btn-primary'>Add</button>
              </div>
            </div>
          </form>
        }
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon,
  category: state.category,
  inventory: state.inventory
})

const dispatchToProps = (dispatch) => ({
  postCouponItem: (data) => dispatch(CouponActions.postCouponItemRequest(data)),
  postCouponItemTag: (data) => dispatch(CouponActions.postCouponItemTagRequest(data))
})

export default connect(stateToProps, dispatchToProps)(IndividualEcommerce)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/IndividualEcommerce.js